import { data } from '../../svg/AreaChart/data';
import { makeIcon } from '../makeIcon';

export const AreaChart = makeIcon(data, 'area_chart', 'AreaChart');

export default AreaChart;
